import styled from "styled-components";

export const LeftSideContainer = styled.div`
  width: 50%;
`;
